import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth, formatApiError } from "@/lib/auth";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Seo } from "@/components/seo/Seo";

export const Login = () => {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      nav(u.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Seo
        title="Sign in"
        description="Sign in to your verified clinic account at Discount Fillers."
        path="/login"
        noindex
      />
      <Header />
      <main className="max-w-md mx-auto px-6 pt-32 pb-24" data-testid="login-page">
        <div className="text-[11px] tracking-[0.3em] uppercase text-neutral-500 mb-3 font-medium">Account</div>
        <h1 className="font-heading text-4xl md:text-5xl font-black tracking-tight leading-[1.05] mb-8">
          Sign in.
        </h1>

        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            <span className="text-[10px] tracking-[0.2em] uppercase text-neutral-500 font-medium">Email</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full border border-neutral-300 px-4 py-3 text-sm focus:outline-none focus:border-black"
              data-testid="login-email"
            />
          </label>
          <label className="block">
            <span className="text-[10px] tracking-[0.2em] uppercase text-neutral-500 font-medium">Password</span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full border border-neutral-300 px-4 py-3 text-sm focus:outline-none focus:border-black"
              data-testid="login-password"
            />
          </label>
          {error && <div className="text-sm text-red-600 border border-red-200 bg-red-50 px-3 py-2" data-testid="login-error">{error}</div>}
          <button
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-black text-white text-sm font-medium hover:bg-neutral-800 disabled:opacity-60"
            data-testid="login-submit"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>

        <p className="mt-6 text-sm text-neutral-600">
          New clinic? <Link to="/register" className="border-b border-black pb-0.5 font-medium" data-testid="login-to-register">Apply for an account →</Link>
        </p>
      </main>
      <Footer />
    </>
  );
};
